import { motion } from "framer-motion";

// Peacock-feather splash: soft light particles + a couple of translucent
// feather curls behind the message. Fades in and out over ~1.5s.
// Colors sampled from a peacock feather eye (teal, blue, gold, soft green).

const PARTICLES = [
  { x: -18, y: -22, r: 22, c: "rgba(46,95,171,0.28)" },   // deep blue
  { x: 34, y: -14, r: 18, c: "rgba(15,163,163,0.28)" },   // teal
  { x: 62, y: 26, r: 24, c: "rgba(197,160,89,0.28)" },    // gold
  { x: -30, y: 40, r: 20, c: "rgba(91,173,126,0.22)" },   // soft green
  { x: 80, y: 60, r: 16, c: "rgba(15,163,163,0.22)" },
  { x: 10, y: 70, r: 14, c: "rgba(197,160,89,0.22)" },
  { x: 46, y: -34, r: 12, c: "rgba(46,95,171,0.25)" },
];

export default function PeacockSplash({ active = true }) {
  return (
    <div className="pointer-events-none absolute inset-0 -z-0 overflow-visible">
      {/* Soft ambient wash */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={active ? { opacity: [0, 0.6, 0], scale: [0.95, 1.05, 1.02] } : { opacity: 0 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at 25% 40%, rgba(15,163,163,0.18), transparent 55%), radial-gradient(circle at 75% 60%, rgba(197,160,89,0.22), transparent 60%), radial-gradient(circle at 55% 20%, rgba(46,95,171,0.12), transparent 55%)",
          filter: "blur(6px)",
        }}
      />

      {/* Light particles */}
      {PARTICLES.map((p, i) => (
        <motion.span
          key={i}
          initial={{ opacity: 0, scale: 0.6, x: 0, y: 0 }}
          animate={
            active
              ? {
                  opacity: [0, 0.9, 0],
                  scale: [0.6, 1.15, 1],
                  x: [0, p.x, p.x * 1.1],
                  y: [0, p.y, p.y * 1.05],
                }
              : { opacity: 0 }
          }
          transition={{
            duration: 1.5,
            delay: i * 0.05,
            ease: "easeOut",
          }}
          className="absolute rounded-full"
          style={{
            left: "50%",
            top: "50%",
            width: p.r,
            height: p.r,
            background: p.c,
            filter: "blur(6px)",
            transform: "translate(-50%, -50%)",
          }}
        />
      ))}

      {/* Feather curl 1 */}
      <motion.svg
        initial={{ opacity: 0, y: 10, rotate: -12 }}
        animate={active ? { opacity: [0, 0.45, 0], y: [10, -6, -10], rotate: [-12, -6, -4] } : { opacity: 0 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        viewBox="0 0 80 120"
        className="absolute -left-6 -top-6"
        width="60"
        height="90"
      >
        <defs>
          <linearGradient id="ps-f1" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#5BAD7E" />
            <stop offset="55%" stopColor="#0FA3A3" />
            <stop offset="100%" stopColor="#2E5FAB" />
          </linearGradient>
        </defs>
        <path
          d="M40 10 C 20 30, 20 70, 34 90 C 46 78, 50 42, 40 10 Z"
          fill="url(#ps-f1)"
          opacity="0.7"
        />
        <ellipse cx="40" cy="30" rx="4" ry="7" fill="#C5A059" opacity="0.85" />
      </motion.svg>

      {/* Feather curl 2 */}
      <motion.svg
        initial={{ opacity: 0, y: -10, rotate: 12 }}
        animate={active ? { opacity: [0, 0.35, 0], y: [-10, 6, 12], rotate: [12, 6, 4] } : { opacity: 0 }}
        transition={{ duration: 1.5, delay: 0.1, ease: "easeOut" }}
        viewBox="0 0 80 120"
        className="absolute -right-4 -bottom-6"
        width="52"
        height="78"
      >
        <defs>
          <linearGradient id="ps-f2" x1="1" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#5BAD7E" />
            <stop offset="55%" stopColor="#0FA3A3" />
            <stop offset="100%" stopColor="#2E5FAB" />
          </linearGradient>
        </defs>
        <path
          d="M40 10 C 20 30, 20 70, 34 90 C 46 78, 50 42, 40 10 Z"
          fill="url(#ps-f2)"
          opacity="0.55"
        />
        <ellipse cx="40" cy="30" rx="4" ry="7" fill="#C5A059" opacity="0.85" />
      </motion.svg>
    </div>
  );
}
